<template>
  <div>
    <div class="title" :style="isNotLogin?'':{backgroundColor: '#044995', color: '#fff'}">
      <div class="left-content">
        长沙县卫生健康局局长信箱
      </div>
      <div class="right-content" @click="()=>{this.isDdialogShow = true}">×</div>
    </div>
    
    <div class="title-btn-box" v-if="isNotLogin">
      <div>
        <el-button class="tbtn" style="background-color: #FE9857;"  type="warning" round @click="toRoutePath('/H5/mailbox')">
          <img class="header-icon" src="../../assets/images/header-btn-write.png" />
          我要写信
        </el-button>
        <el-button class="tbtn" style="background-color: #2066DC;border-color: #2066DC;margin:0 0.28rem 0 0.16rem;"  type="primary" round @click="toRoutePath('/H5/client')">
          <img class="header-icon" src="../../assets/images/header-btn-read.png" />
          我要查信
        </el-button>
      </div>
    </div>

    <div class="content">
      <slot></slot>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="isDdialogShow"
      width="80%"
      :close-on-click-modal=false
      :close-on-press-escape = false
      >
      <span>
        <i class="el-icon-info" style="color: #2b80ff"></i>
        您要退出登录吗！
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAgenFun(false)">取 消</el-button>
        <el-button type="primary" @click="dialogAgenFun(true)">确 定</el-button>
        
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
    data() {
        return {
          isDdialogShow: false,
        }
    },
    props: {
        isNotLogin: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
    },
    methods: {
      toRoutePath(rout) {           
        if(this.$route.path != rout){
          this.$router.push(rout)
        }
      },
      // 退出登录
      logout() {
        // 退出提示
        this.$store.dispatch('LogoutAction')
        this.$router.replace('/H5/login')
      },
      // x 弹框
      dialogAgenFun(flag) {
      if(flag) {
        this.logout()
      }else {
        this.isDdialogShow = false
      }
    },
    }
}

</script>

<style lang="scss" scoped>
// 根据宽度，跳转头部样式
$screenDiff-width: 800px;

.title {
    background: #044995;
    color: #FFFFFF;
    height: 0.88rem;
    
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-content {
      margin-left: 0.37rem;
      font-size: 0.28rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .right-content {
      font-size: 0.64rem;
      margin-right: 0.28rem;
    }

    .breadcrumb {
      display: none;

      .boxarea {
        width: 1rem;
        margin-left: 0.1rem;
        border-radius: 0.15rem;
        background-color: rgb(246,246,246);
        padding: 0.04rem 0.02rem;
        height: 0.2rem;

        display: flex;
        align-items: center;
        .el-dropdown-link {
          letter-spacing: 2px;
          font-size: 0.1rem;
        }
      }
    }
}

.title-btn-box{
  background-color: #FFFFFF;
  height: 0.78rem;
  display: flex;
  justify-content: end;
  align-items: center;

  .title-name {
    display: none;
  }
  .tbtn {
    width: 1.95rem;
    height: 0.46rem; 

    span {
      font-size: 0.28rem;
    }
  }
  /deep/ .el-button.is-round {
    padding: 0;
  }

  /deep/ .el-button>span {
    font-size: 0.28rem;
  }

  .logout-box {
    color: #fff;
    background: #fb6359;
    border-radius: 20px;
    font-size: 0.14rem;
    width: 0.7rem;
    height: 0.22rem;
    line-height: 0.22rem;
    text-align: center;
  }
  .header-icon {
    width: 0.24rem;
  }
}

.content {
  // height: calc(100vh - 0.88rem -0.78rem);
  overflow: auto;
  background-color: #F9F9F9;

}
</style>